import { render, staticRenderFns } from "./CustomerDialog.vue?vue&type=template&id=5e1f3d75&scoped=true"
import script from "./CustomerDialog.vue?vue&type=script&lang=js"
export * from "./CustomerDialog.vue?vue&type=script&lang=js"
import style0 from "./CustomerDialog.vue?vue&type=style&index=0&id=5e1f3d75&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1f3d75",
  null
  
)

export default component.exports